<template>
    <div class="customer-create-customer">
        <h1 class="title mb-2">Benutzer anlegen</h1>
        <v-form :value="valid" @input="setValid" v-on:submit.prevent ref="createCustomerForm">
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-radio-group
                        column
                        @change="setScope"
                        label="SAP Scope"
                        :value="scope"
                        :rules="rules.scopes"
                        :disabled="inAction"
                    >
                        <template v-slot:label>
                            <div>SAP Scope
                                <v-btn class="ma-1" outlined @click="setScope('') && setGpNumber('')">
                                    <v-icon left>mdi-close-circle</v-icon> zurücksetzen
                                </v-btn>
                            </div>
                        </template>
                        <v-radio
                            v-for="s in scopes"
                            :key="s"
                            color="success"
                            :value="s"
                            :label="s"
                        >
                        </v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="gpNumber"
                        @input="setGpNumber"
                        :disabled="inAction || scope === ''"
                        :rules="rules.gpNumber"
                        label="GP-Nummer"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md12>
                    <v-radio-group
                        column
                        @change="setPortal"
                        label="Portal"
                        :rules="rules.portal"
                        :value="portal"
                        :disabled="inAction"
                    >
                        <v-radio
                            v-for="p in portals"
                            :key="p.value"
                            :color="p.color"
                            :value="p.value"
                            :label="p.label">
                        </v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-select
                        :value="anrede"
                        @input="setAnrede"
                        :disabled="inAction"
                        :items="anreden"
                        :rules="rules.anrede"
                        label="Anrede"
                    ></v-select>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="title"
                        @input="setTitle"
                        :disabled="inAction"
                        :rules="rules.title"
                        label="Titel"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-text-field
                        :value="vorname"
                        @input="setVorname"
                        :disabled="inAction"
                        :rules="rules.vorname"
                        label="Vorname"
                    ></v-text-field>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="nachname"
                        @input="setNachname"
                        :disabled="inAction"
                        :rules="rules.nachname"
                        label="Nachname"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-text-field
                        :value="email"
                        @input="setEmail"
                        :disabled="inAction"
                        :rules="rules.email"
                        v-on:keyup="resetAlert"
                        type="email"
                        label="Email"
                    ></v-text-field>
                    <v-alert :type="alert.type" v-model="alert.show">
                        {{ alert.message }}
                    </v-alert>
                    <v-checkbox
                            v-if="existInEvalanche && !existInCeleraone"
                            :value="createAnyway"
                            @change="setCreateAnyway"
                            :rules="rules.createAnyway"
                            :disabled="inAction"
                            label="Benutzer trotzdem anlegen?"
                    ></v-checkbox>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="passwort"
                        @input="setPasswort"
                        :disabled="inAction"
                        :type="passwordInputType"
                        :rules="rules.password"
                        :append-icon="appendIcon"
                        @click:append="hidePassword = !hidePassword"
                        label="Passwort"
                    >
            </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md12>
                    <v-text-field
                        :value="telnr"
                        @input="setTelnr"
                        :disabled="inAction"
                        :rules="rules.telnr"
                        label="Telefon"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-text-field
                        :value="strasse"
                        @input="setStrasse"
                        :disabled="inAction"
                        :rules="rules.strasse"
                        label="Straße"
                    ></v-text-field>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="hausnummer"
                        @input="setHausnummer"
                        :disabled="inAction"
                        :rules="rules.hausnummer"
                        label="Hausnummer"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between mb-2>
                <v-flex md6 pr-2>
                    <v-text-field
                        :value="plz"
                        @input="setPlz"
                        :disabled="inAction"
                        :rules="rules.plz"
                        label="Postleitzahl"
                    ></v-text-field>
                </v-flex>
                <v-flex md6 pl-2>
                    <v-text-field
                        :value="ort"
                        @input="setOrt"
                        :disabled="inAction"
                        :rules="rules.ort"
                        label="Ort"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex my-5>
                    <v-btn outlined :disabled="inAction" @click="reset">
                        Zurücksetzen
                    </v-btn>
                    <ConfirmationDialog
                        :alternativeBtn="true"
                        :loading="inAction"
                        @submit="submitForm"
                        outlined
                        btnText="Benutzer anlegen"
                        btnClass="ml-3"
                        submitText="Benutzer anlegen"
                        abortText="Abbrechen"
                        dialogTitle="Benutzer anlegen"
                        dialogText="Mit betätigen des Buttons 'Benutzer anlegen' wird ein neuer Benutzer in den Systemen Celeraone, Evalanche und Salesforce angelegt. Möchten Sie wirklich einen neuen Benutzer anlegen?"
                    />
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapGetters,
    mapState,
} from 'vuex';
import Util from '@/util';
import Route from '@/route';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';

export default {
    name: 'CreateCustomer',
    components: {
        ConfirmationDialog,
    },
    data() {
        return {
            hidePassword: true,
            anreden: ['Herr', 'Frau', 'Firma'],
            rules: {
                anrede: [
                    v => this.anreden.indexOf(v) > -1 || 'Ungültige Anrede',
                ],
                title: [
                    v => v.length <= 10 || 'Titel darf maximal 10 Zeichen lang sein.',
                ],
                portal: [
                    v => !!v || 'Es muss ein Portal ausgewählt werden',
                ],
                vorname: [
                    v => !!v || 'Vorname muss gesetzt sein.',
                    v => v.length <= 35 || 'Vorname darf maximal 35 Zeichen lang sein.',
                ],
                nachname: [
                    v => !!v || 'Nachname muss gesetzt sein.',
                    v => v.length <= 35 || 'Nachname darf maximal 35 Zeichen lang sein.',
                ],
                strasse: [
                    v => v.length <= 35 || 'Straße darf maximal 35 Zeichen lang sein.',
                ],
                hausnummer: [
                    v => v.length <= 10 || 'Hausnummer darf maximal 10 Zeichen lang sein.',
                ],
                plz: [
                    v => v.length <= 5 || 'Postleitzahl darf maximal 5 Zeichen lang sein.',
                ],
                ort: [
                    v => v.length <= 35 || 'Ort darf maximal 35 Zeichen lang sein.',
                ],
                email: [
                    v => !!v || 'Email muss gesetzt sein.',
                    v => /.+@.+/.test(v) || 'Email muss gültig sein.',
                    v => v.length <= 240 || 'Email darf maximal 240 Zeichen lang sein.',
                ],
                gebdat: [
                    v => (Util.isValidGermanDate(v) || !v.trim().length) || 'Geburtsdatum entspircht nicht dem Format TT.MM.JJJJ',
                ],
                telnr: [
                    v => v.length <= 20 || 'Telefonnummer darf maximal 20 Zeichen lang sein.',
                ],
                password: [
                    v => !!v || 'Passwort muss gesetzt sein.',
                    v => v.length > 5 || 'Passwort muss mindestens 6 Zeichen beinhalten.',
                ],
                gpNumber: [
                    v => (!this.scope || !!v) || 'GP-Nummer darf nicht leer sein.',
                ],
                createAnyway: [
                    v => ((this.existInEvalanche && !this.existInCeleraone && v)
                        || (!this.existInCeleraone && !this.existInEvalanche))
                        || 'Warnung muss akzeptiert werden.',
                ],
            },
        };
    },
    computed: {
        ...mapGetters('customerCreate', ['portals']),
        ...mapState('customerCreate', [
            'inAction',
            'valid',
            'portal',
            'scope',
            'scopes',
            'gpNumber',
            'ssoId',
            'anrede',
            'title',
            'vorname',
            'nachname',
            'strasse',
            'hausnummer',
            'plz',
            'ort',
            'land',
            'email',
            'gebdat',
            'telnr',
            'passwort',
            'createAnyway',
            'existInEvalanche',
            'existInCeleraone',
            'alert',
            'redirect',
        ]),
        passwordInputType() {
            return this.hidePassword ? 'password' : 'text';
        },
        appendIcon() {
            return this.hidePassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline';
        },
    },
    methods: {
        ...mapActions('customerCreate', ['submit', 'resetState']),
        submitForm() {
            this.$refs.createCustomerForm.validate();
            if (!this.valid || this.existInCeleraone || (this.existInEvalanche && !this.createAnyway)) {
                return;
            }
            this.submit().then(() => {
                if (this.redirect) {
                    this.$router.push({ name: Route.CUSTOMER_C1.name, params: { sso_id: this.ssoId } });
                    this.reset();
                }
            });
        },
        reset() {
            this.resetState();
            this.$refs.createCustomerForm.resetValidation();
        },
        resetAlert() {
            this.setAlert({
                type: 'error',
                message: '',
                show: false,
            });
            this.setExistInCeleraone(false);
            this.setExistInEvalanche(false);
            this.setCreateAnyway(false);
        },
        ...mapMutations('snackbar', ['success', 'error']),
        ...mapMutations('customerCreate', [
            'setValid',
            'setPortal',
            'setScope',
            'setGpNumber',
            'setAnrede',
            'setTitle',
            'setVorname',
            'setNachname',
            'setStrasse',
            'setHausnummer',
            'setPlz',
            'setOrt',
            'setLand',
            'setEmail',
            'setGebdat',
            'setTelnr',
            'setPasswort',
            'setExistInCeleraone',
            'setExistInEvalanche',
            'setCreateAnyway',
            'setAlert',
        ]),
    },
};
</script>

<style scoped lang="scss"></style>
